/** Walks a paged list route to the end, reporting rows loaded so far. List routes cap their page size, so an export must page. */
export async function fetchAllPages<T>(
  page: (n: number) => Promise<{ data: T[]; meta: { total: number; per_page: number } }>,
  onProgress: (done: number, total: number) => void,
): Promise<T[]> {
  const rows: T[] = [];
  let n = 1;
  for (;;) {
    const res = await page(n);
    rows.push(...res.data);
    onProgress(rows.length, res.meta.total);
    if (res.data.length === 0 || rows.length >= res.meta.total) return rows;
    n += 1;
  }
}
